module.exports = __webpack_public_path__ + "static/media/Highland Ave San Carlos, CA5.8ea847e7.jpg";